import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';
// import Cookies from 'js-cookie';
import './LoginPage.css';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {

      const mpayload = { username: username, password: password }
      console.log('Payload', mpayload)
      const res = await api.post('/login', mpayload);
      const token = res.data.data.token;
      localStorage.setItem('token', token)
      console.log('Respon Login', res)
      // Set token in cookies
      // Cookies.set('token', token, {
      //   expires: rememberMe ? 7 : null, // 7 days if rememberMe, session cookie otherwise
      //   secure: true,
      //   sameSite: 'none',
      // });
      // console.log('Cookies', Cookies)
      if (rememberMe) {
        localStorage.setItem('rememberMe', 'true');
        localStorage.setItem('username', username);
      } else {
        localStorage.removeItem('rememberMe');
        localStorage.removeItem('username');
      }

      navigate('/admin');
    } catch (err) {
      const message = err.response?.data?.responseMessage || 'Login failed. Please try again.';
      alert(message);
    }
  };

  return (
    <div className="login-page">
      <div className="overlay"></div>
      <div className="login-card card shadow-lg p-4 " style={{ width: '400px', background:'#FFFFFF1A'}}>
        <div className="text-center mb-3">
          <img src="/logo192.png" alt="Logo" className="login-logo" />
        </div>

        <h3 className="text-center mb-4 text-white">Welcome Back</h3>

        <div className="mb-3">
          <label className="form-label  text-white">Username</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoFocus
          />
        </div>

        <div className="mb-3">
          <label className="form-label  text-white ">Password</label>
          <input
            type="password"
            className="form-control"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <div className="form-check mb-3">
          <input
            type="checkbox"
            className="form-check-input"
            id="rememberMe"
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
          />
          <label className="form-check-label text-white" htmlFor="rememberMe">
            Remember me
          </label>
        </div>

        <button className="btn btn-light w-100 fw-bold" onClick={handleLogin}>
          Login
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
